<template>
  <div>
    <!-- Botón para abrir el modal -->
    <!-- <button @click="showModal = true" class="bg-blue-600 text-white px-4 py-2 rounded">Open Modal</button> -->
    <a v-if="project.permissions.project.share" class="btn-blue" href="#" @click="showModal = true"><span>Email Documents</span></a>
    <!-- Modal -->
    <div v-if="showModal" class="fixed inset-0 bg-gray-800 bg-opacity-75 flex items-center justify-center z-50">
      <div class="bg-white p-6 rounded-lg shadow-lg w-full max-w-lg">
        <div class="flex justify-between items-center mb-6">
          <h2 class="text-xl font-semibold">Email Documents</h2>
          <button @click="showModal = false" class="text-gray-400 hover:text-gray-600">&times;</button>
        </div>

        <div class="space-y-4">
          <!-- Attachments Section -->
          <div>
            <h3 class="text-lg font-medium">Attachments</h3>
            <div class="flex flex-wrap gap-4 mt-2">
              <label v-for="(attachment, index) in attachments" :key="index" class="flex items-center space-x-2">
                <input type="checkbox" v-model="selectedAttachments" :value="attachment.value" class="form-checkbox text-blue-600">
                <span>{{ attachment.label }}</span>
              </label>
            </div>
          </div>

          <!-- Email Recipients -->
          <div>
            <label for="recipients" class="block text-sm font-medium text-gray-700">Email Recipients</label>
            <v-multiselect
              v-model="mails"
              :options="usersOptions"
              :taggable="true"
              :close-on-select="false"
              :clear-on-select="false"
              :multiple="true"
              :searchable="true"
              :filterable="false"
              @tag="addEmail"
              @remove="removeEmail"
              :custom-label="nameWithMail"
              @search-change="onSearch"
              track-by="email"
              placeholder="Add recipients by name or email"
              class="mt-2"
            ></v-multiselect>
          </div>

          <!-- Custom Message -->
          <div>
            <label for="message" class="block text-sm font-medium text-gray-700">Include a custom message (optional)</label>
            <textarea v-model="message"
              id="message"
              placeholder="Include a custom message (optional)"
              class="mt-2 p-2 block w-full border border-gray-300 rounded-md shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-200"
            ></textarea>
          </div>
        </div>

        <div class="mt-6 flex justify-end space-x-3">
          <button @click="showModal = false" class="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600">Cancel</button>
          <button @click="sendEmail" class="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700">Send Email</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VMultiselect from 'vue-multiselect'
import { debounce } from 'lodash';

export default {
  props: {
    project    : Object,
    modelValue : [String, Number],
    users      : Array,
    members    : Array,
    permissions: Object,
    company    : Object,
  },
  components: {
    VMultiselect,
  },
  data() {
    return {
      showModal: false,
      selectedAttachments: [],
      attachments: [
        { label: 'Drawings', value: 'drawings' },
        { label: 'BOM', value: 'bom' },
        { label: 'Quote PDF', value: 'quote_pdf' },
        { label: 'Quote CSV', value: 'quote_csv' },
        { label: 'Spec Sheets', value: 'spec_sheets' },
        { label: 'BOM by Run', value: 'bom_by_run' },
        { label: 'Quote by Run PDF', value: 'quote_by_run_pdf' },
      ],
      mails: [],
      usersOptions: [],
      message: '',
    };
  },
  methods: {
    onSearch: debounce(function(searchTerm) {
      if (searchTerm.length > 2) {
        this.fetchRecipients(searchTerm);
      }
    }, 500),
    fetchRecipients(searchTerm) {
      this.$inertia.visit(`/projects/${this.project.id}/?userSearch=${searchTerm}`, {
        method: 'get',
        preserveState: true, // Preserva el estado de la página
        preserveScroll: true, // Preserva la posición del scroll
        only: ['users'], // Solo actualiza la propiedad `users` en los props
        onSuccess: (page) => {

          // Solo añade los usuarios que no están ya en `usersOptions`
          const newUsers = page.props.users.filter(user =>
            !this.usersOptions.some(existingUser => existingUser.email === user.email)
          );

          // Añade los nuevos usuarios a la lista
          this.usersOptions = [...this.usersOptions, ...newUsers];
        },
      });
    },
    addEmail(email) {
      const validEmail = this.validateEmail(email); // Valida el email
      if (validEmail) {
        // Si no existe en el array, agrégalo
        if (!this.mails.some(mail => mail.email === validEmail.email)) {
          this.mails = [...this.mails, validEmail]; // Evita mutaciones directas
        }
      }
      return validEmail || false;
    },
    removeEmail(email) {
      // Usa un array filtrado en lugar de mutar directamente el array original
      this.mails = this.mails.filter(mail => mail.email !== email.email);
    },
    validateEmail(email) {
      const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (emailPattern.test(email)) {
        return { id: null, email: email, name: email, owner: null, photo: null, type: 'user' };
      }
      return false;
    },
    nameWithMail ({ email }) {
      return `${email}`;
    },
    sendEmailold() {
      this.$inertia.post(`/projects/${this.project.id}/send-quote`, {
        project_id: this.project.id,
        attachments: this.selectedAttachments,
        mails: this.mails,
        message: this.message,
      }, {
        onSuccess: (result) => {
          this.showModal = false;
        },
        onError: (errors) => {
          // Maneja errores aquí si es necesario
        },
      });
    },
    // sendEmail() {
    //   // Convertimos los datos en una cadena de consulta para pasarlos por la URL
    //   const queryParams = new URLSearchParams({
    //     project_id: this.project.id,
    //     attachments: this.selectedAttachments.join(','), // Convertimos el array a una cadena separada por comas
    //     mails: JSON.stringify(this.mails), // Convertimos el array de mails a JSON string
    //     message: this.message || '', // Aseguramos que el mensaje no sea nulo
    //   }).toString();

    //   // Hacemos una solicitud GET utilizando la nueva ruta
    //   this.$inertia.get(`/projects/${this.project.id}/mail?${queryParams}`, {}, {
    //     onSuccess: (result) => {
    //       this.showModal = false;
    //     },
    //     onError: (errors) => {
    //       // Maneja errores aquí si es necesario
    //     },
    //   });
    // },
    sendEmail() {
      if (this.selectedAttachments.length === 0) {
        alert('Please select at least one attachment before sending the email.');
        return;
      }
      // Convertimos los datos en una cadena de consulta para pasarlos por la URL
      const queryParams = new URLSearchParams({
        project_id: this.project.id,
        attachments: this.selectedAttachments.join(','), // Convertimos el array a una cadena separada por comas
        mails: JSON.stringify(this.mails), // Convertimos el array de mails a JSON string
        message: this.message || '', // Aseguramos que el mensaje no sea nulo
      }).toString();

      // Abre una nueva ventana con la URL para enviar el correo
      const newWindow = window.open(`/bulk/${this.project.id}/mail?${queryParams}`, '_blank');

      // Chequea si la ventana se ha abierto correctamente
      if (newWindow) {

        // Monitorea si la ventana ha sido cerrada
        const timer = setInterval(() => {
          if (newWindow.closed) {
            clearInterval(timer); // Detenemos el chequeo cuando la ventana se cierre
            this.showModal = false; // Oculta el modal en tu app
          }
        }, 1000); // Revisa cada segundo si la ventana sigue abierta
      } else {
        // Si la ventana no pudo abrirse, puedes manejar el error aquí (por ejemplo, bloqueos de pop-ups)
        console.error('No se pudo abrir la ventana para enviar el correo.');
      }
    }

  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.css"></style>
<style>

.multiselect__select {
  right: 20px !important; /* Ajusta según sea necesario */
}
.multiselect__tags {
  border-radius: 0 !important;
  border-color: rgba(212, 212, 216, var(--tw-border-opacity)) !important;
}

.multiselect__option--highlight,
.multiselect__option--highlight::after,
.multiselect__tag  {
  background-color: #0052A4 !important;
  /* color: #000; Ajusta el color del texto si es necesario */
}
.multiselect__spinner {
  border-color: #0052A4 transparent transparent transparent; /* Cambia el primer valor para el color deseado */
}
</style>
